import { Button, ButtonProps, Tooltip } from 'antd';
import { useTranslate } from '@tolgee/react';

function ForwardToAgent(props: ButtonProps) {
  const { t } = useTranslate();
  return (
    <Tooltip title={t('ViewRefund.暂不支持该状态，请前往Lazada退款详情进行处理')}>
      <Button disabled size="small" {...props}>
        {t('ViewRefund.转发给代理')}
      </Button>
    </Tooltip>
  );
}

export default ForwardToAgent;
